(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cv-collection-molecules"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-cv-filter]').forEach(function(container) {
    var pills = container.querySelectorAll('.cv-cm-pill');
    var section = container.closest('section');
    if (!section) return;
    var cards = section.querySelectorAll('.cv-cm-card');
    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        var filter = pill.dataset.filter;
        pills.forEach(function(p) { p.classList.remove('cv-cm-pill-active'); });
        pill.classList.add('cv-cm-pill-active');
        cards.forEach(function(card) {
          var key = card.dataset.filterKey || 'all';
          if (filter === 'all' || key === filter) {
            card.removeAttribute('data-filter-hidden');
          } else {
            card.setAttribute('data-filter-hidden', '');
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-hero-product"]) return;
  try {
    
window.cvSelectBundle = function(el, sectionId) {
  var bundles = el.parentElement.querySelectorAll('.cv-bundle-opt');
  bundles.forEach(function(b) { b.classList.remove('active'); });
  el.classList.add('active');

  var price = el.dataset.price;
  var variantId = el.dataset.variantId;
  var supply = el.dataset.supply;

  var priceEl = document.getElementById('cv-price-display-' + sectionId);
  var supplyEl = document.getElementById('cv-supply-display-' + sectionId);
  var variantEl = document.getElementById('cv-variant-' + sectionId);
  var ctaEl = document.getElementById('cv-cta-' + sectionId);

  var currencySymbol = priceEl ? priceEl.querySelector('sup').textContent : '€';

  if (priceEl) priceEl.innerHTML = '<sup>' + currencySymbol + '</sup>' + price + '<sub>,00</sub>';
  if (supplyEl) supplyEl.textContent = supply;
  if (variantEl && variantId) variantEl.value = variantId;
  if (ctaEl) {
    var ctaTextRaw = ctaEl.dataset.ctaTextRaw || ctaEl.textContent.split('—')[0].trim();
    ctaEl.dataset.ctaTextRaw = ctaTextRaw;
    ctaEl.innerHTML = ctaTextRaw + ' — ' + currencySymbol + price + '<svg width="14" height="12" viewBox="0 0 14 12" fill="none"><path d="M1 6h11M8 1l4 5-4 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  // Sync sticky ATC
  var stickyPrice = document.getElementById('cv-sticky-price-' + sectionId);
  var stickySupply = document.getElementById('cv-sticky-supply-' + sectionId);
  if (stickyPrice) stickyPrice.textContent = currencySymbol + price;
  if (stickySupply) stickySupply.textContent = supply;
};

document.addEventListener('DOMContentLoaded', function() {
  // Sticky ATC buy — delegate clicks via event listener (avoids inline onclick scope issues)
  document.querySelectorAll('[data-cv-sticky-buy]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var sectionId = btn.dataset.sectionId;
      var cta = document.getElementById('cv-cta-' + sectionId);
      if (cta && !cta.disabled) cta.click();
    });
  });

  // Sticky ATC: show when main CTA scrolls out of view
  document.querySelectorAll('.cv-sticky-atc').forEach(function(sticky) {
    var sectionId = sticky.dataset.sectionId;
    var mainCta = document.getElementById('cv-cta-' + sectionId);
    if (!mainCta || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('cv-visible');
          sticky.setAttribute('aria-hidden', 'true');
        } else {
          // Only show if scrolled DOWN past CTA (not above)
          var rect = mainCta.getBoundingClientRect();
          if (rect.bottom < 0) {
            sticky.classList.add('cv-visible');
            sticky.setAttribute('aria-hidden', 'false');
          } else {
            sticky.classList.remove('cv-visible');
            sticky.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }, { threshold: 0, rootMargin: '0px' });

    observer.observe(mainCta);
  });

  document.querySelectorAll('form[id^="cv-add-form-"]').forEach(function(form) {
    var sectionId = form.dataset.sectionId;

    // Thumb click swaps main image
    var section = form.closest('.cv-hero-section');
    if (section) {
      section.querySelectorAll('.cv-g-thumb[data-img]').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          section.querySelectorAll('.cv-g-thumb').forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          var mainImg = document.getElementById('cv-gallery-main-img-' + sectionId);
          if (mainImg) mainImg.src = thumb.dataset.img;
        });
      });
    }

    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      var btn = document.getElementById('cv-cta-' + sectionId);
      var originalHTML = btn.innerHTML;
      btn.innerHTML = 'Добавяне...';
      btn.disabled = true;

      try {
        var formData = new FormData(form);
        formData.append('sections', 'cart-drawer,header');
        formData.append('sections_url', window.location.pathname);

        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        var result = await addRes.json();
        if (!addRes.ok) throw new Error(result.description || 'Грешка при добавяне в количката');

        // Refresh + open Elixir cart drawer
        if (result.sections && result.sections['cart-drawer']) {
          var parser = new DOMParser();
          var newDoc = parser.parseFromString(result.sections['cart-drawer'], 'text/html');
          var selectors = ['cart-drawer', '#cart-drawer', '[data-cart-drawer]', '.cart-drawer'];
          for (var i = 0; i < selectors.length; i++) {
            var newDrawer = newDoc.querySelector(selectors[i]);
            var oldDrawer = document.querySelector(selectors[i]);
            if (newDrawer && oldDrawer) {
              oldDrawer.parentNode.replaceChild(newDrawer, oldDrawer);
              break;
            }
          }
        }

        // Dispatch standard cart events for any listener
        ['cart:refresh', 'cart:updated', 'cart-drawer:open'].forEach(function(name) {
          document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: result }));
        });

        // Try to open drawer
        var drawer = document.querySelector('cart-drawer, [data-cart-drawer], #cart-drawer, .cart-drawer');
        if (drawer) {
          if (typeof drawer.open === 'function') drawer.open();
          else drawer.classList.add('active', 'is-open', 'open');
        }

        btn.innerHTML = '✓ Добавено!';
        setTimeout(function() { btn.innerHTML = originalHTML; btn.disabled = false; }, 1500);
      } catch (err) {
        console.error('[CV] Add error:', err);
        btn.innerHTML = '❌ Опитай отново';
        setTimeout(function() { btn.innerHTML = originalHTML; btn.disabled = false; }, 2500);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
